import { render, staticRenderFns } from "./app-detail-appointment.vue?vue&type=template&id=5b3e1bc6&scoped=true&"
import script from "./app-detail-appointment.vue?vue&type=script&lang=js&"
export * from "./app-detail-appointment.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-appointment.vue?vue&type=style&index=0&id=5b3e1bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3e1bc6",
  null
  
)

export default component.exports